import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, G, Defs, ClipPath } from 'react-native-svg';

const MB_SVG_EyeOff = React.memo(
  (props: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The color of the component.
     */
    color?: string;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.size ?? 24} height={props.size ?? 24} viewBox="0 0 24 24" fill="none">
          <G clipPath="url(#clip0_17440_38714)" stroke={props.color ?? '#BAC0CA'} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            <Path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.494 18.494 0 01-2.16 3.19m-6.72-1.07a2.998 2.998 0 01-5.194-2.098A3 3 0 019.88 9.88M1 1l22 22" />
          </G>
          <Defs>
            <ClipPath id="clip0_17440_38714">
              <Path fill={props.color ?? '#BAC0CA'} d="M0 0H24V24H0z" />
            </ClipPath>
          </Defs>
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_EyeOff };
